<script>


export default {
	name: 'BadStory8',
	props: ['alpha'],
}
</script>



<template>
<div class="story small half" :style="{opacity: alpha}">
	<img class="image" src="../assets/bad/story8.jpg">
	<div class="mask">
		<h2>&#9744;&#9744;&#9744;&#9744; &#9744;&#9744;&#9744;</h2>
		<p>&#9744;&#9744;&#9744;&#9744; &#9744;&#9744;&#9744;&#9744;&#9744;&#9744;&#9744; &#9744;&#9744;&#9744;&#9744;&#9744;&#9744;&#9744; &#9744;&#9744;&#9744; &#9744;&#9744;&#9744;&#9744;&#9744;&#9744;</p>
	</div>
</div>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.story {
	float: left;
	position: relative;
	overflow: hidden;
	background: #000;
}

.small {
	width: 25vw;
	height: 25vw;
}

.image {
	width: 101%;
	height: 101%;
	position: absolute;
	background-size: cover;
	background-position: center;
	transition: all 300ms ease;
}

.mask {
	width: 100%;
	height: 102%;
	position: absolute;
	background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

.half .image {
	height: 51%;
}

.half .mask {
	height: 50%;
	top: 50%;
	justify-content: flex-start;
	background: #fff;
	color: #000;
	border-right: 1px solid grey;
	box-sizing: border-box;
	border-right: 1px solid rgba(0,0,0,0.1);
	box-sizing: border-box;
}

h2 {
	width: 90%;
	margin: 0 auto;
	font-size: 23px;
}

p {
	width: 90%;
	margin: 0 auto;
	padding-bottom: 5vh;
	font-size: 23px;
	font-family: @fontLava;
	font-weight: 600;
	transition: all 200ms ease;
}

.half h2 {
	color: @red;
	padding: 1vh 0;
	font-size: 15px;
}

.half p {
	font-size: 18px;
	font-weight: 400;
}

.border {
	width: 100%;
	height: 100%;
	position: absolute;
	pointer-events: none;
	box-sizing: border-box;
	border: 0px solid @red;
	transition: all 200ms ease;
}




</style>



// WEBPACK FOOTER //
// BadStory8.vue?971c68e4